import styled, { createGlobalStyle } from 'styled-components';

export const theme = {
    primaryColor: "#a18039",
    secondaryColor: "#debe7b",
    darkColor: "#000",
    lightColor: "#fff",
    greyColor: "#f7f7f7"
}

export const GlobalStyles = createGlobalStyle`

    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    body {
        font-family: 'Roboto Condensed', sans-serif;
    }

    h1, h2, h3, h4, h5, h6 {
        font-family: 'Merriweather', sans-serif;
    }

    a {
        text-decoration: none;
    }

    .container {
        max-width: 1100px;
        margin: 0 auto;
    }

    .btn {
        padding: 0.8rem 3rem;
        background-color: ${ props => props.theme.primaryColor };
        color: ${ props => props.theme.lightColor };
        border: none;
        cursor: pointer;
        border-radius: 0.5rem;
        font-weight: 500;
        font-size: 1.1rem;
        display: inline-block;

        @media (max-width: 500px){

            font-size: 1rem;

        }
    }

    .effect {
        color: ${ props => props.theme.secondaryColor };
    }

`

export const DonateBlock = styled.section`

    padding: 3rem 0;
    background-color: ${ props => props.theme.secondaryColor };

    @media (max-width: 1024px){
        padding: 3rem 1.5rem;
    }

    .container {

        display: flex;
        justify-content: space-between;
        align-items: center;

        svg {
            color: ${ props => props.theme.lightColor};
            font-size: 2.5rem;
        }

        h3 {
            color: ${ props => props.theme.lightColor};
            font-size: 2rem;

        }

        @media (max-width: 768px){

            h3 {
                font-size: 1.2rem;
            }

            svg {
                font-size: 2rem;
            }

        }

        @media (max-width: 500px){

            flex-direction: column;

            h3 {
                font-size: 1rem;
                margin: 1rem 0;
            }

        }

    }

`

export const PageNotFound = styled.section`

    padding: 3rem 0;
    background-color: ${ props => props.theme.greyColor };
    text-align: center;

    @media (max-width: 1024px){
        padding: 3rem 1.5rem;
    }

    .container {

        h2 {
            font-size: 1.5rem;
            margin-bottom: 1rem;
        }

        p {
            font-weight: 300;
            margin-bottom: 1rem;
        }

    }

`

export const BecomeSponsor = styled.section`

    padding: 3rem 0;
    background-color: ${ props => props.theme.secondaryColor };

    @media (max-width: 1024px){
        padding: 3rem 1.5rem;
    }

    .container {

        display: flex;
        justify-content: space-between;
        align-items: center;

        h3 {
            color: ${ props => props.theme.lightColor};
            font-size: 2rem;
        }

        @media (max-width: 768px){

            h3 {

                font-size: 1.5rem;

            }

        }

        @media (max-width: 500px){

            flex-direction: column;

            h3 {
                font-size: 1.2rem;
                margin-bottom: 1rem;
            }

        }

    }

`

export const Head = styled.header`

    background: url('zapowerhouse-about.jpg') no-repeat center center/cover;
    height: 30rem;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    h2 {
        font-size: 2rem;
        color: ${ props => props.theme.lightColor};
        position: relative;
        z-index: 5;
        margin-bottom: 1rem;

    }

    .links {
        position: relative;
        z-index: 5;

        a {
            color: ${ props => props.theme.secondaryColor};
            display: inline;
        }

        span {
            color: ${ props => props.theme.lightColor};
        }
    }

    &:before{

        content: "";
        background-color: ${ props => props.theme.darkColor};
        opacity: 0.7;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

    }

`

export const Foot = styled.footer`

    background-color: ${ props => props.theme.darkColor };
    padding: 2rem 1rem;

    .container {

        p {
            color: ${ props => props.theme.lightColor };
            text-align: center;
            font-size: 1.2rem;

            @media (max-width: 500px){

                font-size: 0.8rem;

            }

            a {
                color: ${ props => props.theme.primaryColor };
                text-decoration: underline;
            }
        }

    }

`

export const Social = styled.footer`

    background-color: ${ props => props.theme.lightColor };
    padding: 3rem 0;

    @media (max-width: 1024px){

        padding: 3rem 1.5rem;

    }

    .container {

        h2 {
            font-size: 1.5rem;
            text-align: center;
            margin-bottom: 1rem;

        }

        .socials {

            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;

            .social {

                text-align: center;

                h4 {
                    font-size: 1.4rem;
                    margin: 0.5rem 0 0;
                }

                a {
                    color: ${ props => props.theme.primaryColor };
                }

                svg {
                    color: ${ props => props.theme.secondaryColor  };
                    font-size: 2rem;
                }

            }

            @media (max-width: 768px){

                justify-content: flex-start;

                .social {
                    width: 30%;
                    margin-bottom: 1.5rem;

                    h4 {
                        font-size: 1.2rem;
                    }
                }

            }

            @media (max-width: 500px){

                justify-content: center;

                .social {
                    width: 47%;
                }

            }


        }

    }

`

export const MobileNav = styled.nav`

    display: none;
    border-top: 1px solid ${props => props.theme.lightColor};

    @media (max-width: 768px){

        display: flex;
        flex-direction: column;
        background-color: ${ props => props.theme.darkColor };
        padding: 2rem;

        ul {
            display: flex;
            flex-direction: column;
            list-style: none;

            li {

                margin-bottom: 1.5rem;

                a {

                    color: ${props => props.theme.lightColor};
                    padding: 0.6rem 0;

                    &.active {
                        color: ${props => props.theme.secondaryColor};
                    }

                }

            }
        }

        .donate {

            margin-top: 1rem;

        }

    }

`

export const Nav = styled.nav`

    background-color: ${ props => props.theme.darkColor };
    padding: 0.5rem;
    height: 7rem;

    .container {

        display: flex;
        justify-content: space-between;
        align-items: center;

        .logo {

            img {
                width: 8rem;
            }

        }

        ul {
            display: flex;
            justify-content: space-between;
            align-items: center;

            li {
                margin-right: 1rem;

                a {

                    color: ${props => props.theme.lightColor};
                    padding: 0.6rem 0;

                    &.active {
                        color: ${props => props.theme.secondaryColor};
                    }

                    &:hover{
                        color: ${props => props.theme.secondaryColor};
                    }
                }
            }
        }

        svg {
            display: none;
            color: ${props => props.theme.lightColor};
        }

        .donate {
            display: flex;
            align-items: center;
        }

    }

    @media (max-width: 1024px){

        padding: 1rem;
        height: 6.5rem;

    }

    @media (max-width: 768px){

        .container {

            ul {
                display: none;
            }

            .logo {

                img{

                    width: 6rem;

                }

            }

            .donate {
                display: none;
            }

            svg {

                display: block;
                font-size: 1.3rem;

            }

        }

    }

`